import React, { useState } from 'react';
import './TableSortLabel.scss';
import {
  Checkbox, Col, Radio, RadioGroup, Row
} from '@thd-olt-component-react/core-ui';
import { noop } from 'lodash';
import { generateImageSource } from '../../../utils/generateImageSource';
import { useOutsideClick } from '../../../utils/useOutsideClick';

const CHEVRON_SVG = '/images/chevron-symbol.svg';

const chevronDownStyle = {
  width: '15px',
  transform: 'rotateZ(-90deg)',
  marginLeft: '10px'
};

const TableSortLabelDropdown = ({ header, filter, handleFilterChange = noop() }) => {

  const [show, setShow] = useState(false);
  let ref = useOutsideClick(() => setShow(false), ['dropdown', 'thead', 'chevron-down']);

  const { type, values, fallback } = header.items;

  const toggleShow = () => {
    setShow((current) => !current);
  };

  const renderRadioGroup = () => {

    return (
      <RadioGroup>
        {values
          .filter((v) => v?.show)
          .map((option) => {
            return (
              <Radio
                data-testid={`table-sort-radio__${option.key}`}
                id={option.key}
                className="radio-override radio-label-override"
                onChange={(e) => {
                  handleFilterChange(e.target.value);
                }}
                value={option.key}
                checked={filter === option.key || (option.key === fallback && filter === undefined)}
                label={option.value}
                padding
              />
            );
          }
          )}
      </RadioGroup>
    );
  };

  const renderCheckboxes = () => {

    return (
      <>
        <ul className="slm-filter-unit__list">
          {values.map((option) => (
            <li
              key={option.key}
              data-testid={`table-sort-checkbox__${option.key}`}
            >
              <Checkbox
                key={option.key}
                id={option.key}
                onChange={(e) => {
                  handleFilterChange(e.target.value);
                }}
                checked={filter.includes(option.key)}
              >
                {option.value}
              </Checkbox>
            </li>
          ))}
        </ul>
      </>
    );
  };

  return (
    <>
      <span
        className="table-header-with-sort"
        id="thead"
        onClick={toggleShow}
        data-testid={`thead-sort-${header.key}`}
      >
        <div
          className="p2p-table__heading-text-dropdown"
          id="dropdown"
        >
          {header.value}
        </div>
        <img
          id="chevron-down"
          data-testid="chevron-down"
          src={generateImageSource(CHEVRON_SVG)}
          style={chevronDownStyle}
        />
      </span>

      {show && (
        <span ref={ref} style={{ width: '140px', backgroundColor: '#eeeeee', zIndex: 1, marginTop: '15px' }}>
          <Row>
            <Col xs="12">
              {type === 'radio' && renderRadioGroup()}
              {type === 'checkbox' && renderCheckboxes()}
            </Col>
          </Row>
        </span>
      )}
    </>

  );
};

export default TableSortLabelDropdown;
